module.exports = __webpack_public_path__ + "static/media/productos_cacahuate_blanqueado_mitad.f893dd36.jpg";